import { render } from "./ItemView.vue?vue&type=template&id=d5c377ea&scoped=true"
import script from "./ItemView.vue?vue&type=script&lang=js"
export * from "./ItemView.vue?vue&type=script&lang=js"

import "./ItemView.vue?vue&type=style&index=0&id=d5c377ea&scoped=true&lang=css"
import "./ItemView.vue?vue&type=style&index=1&id=d5c377ea&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuemasi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c377ea"]])

export default __exports__